import { OrganizationType } from "../enums/organizationTypes";

export interface AgenticAuthOnFileOrgTab {
  id: string;
  label: string;
}

/** Org tabs (NYCBS, CHC, MBP, UCBC) for Agentic Auth on File configuration. */
export const AGENTIC_AUTH_ON_FILE_ORG_TABS: AgenticAuthOnFileOrgTab[] = [
  { id: OrganizationType.NYCBS, label: "NYCBS" },
  { id: OrganizationType.CHC, label: "CHC" },
  { id: OrganizationType.MBP, label: "MBP" },
  { id: OrganizationType.UCBC, label: "UCBC" },
  { id: OrganizationType.SUNSTATE, label: "SUNSTATE" },
];

/**
 * Orgs shown in the Auth Letter Payer Config "save to organizations" picker.
 *
 * Ordered to match the product facility list (includes NYCBS Stat).
 */
export const AUTH_LETTER_PAYER_CONFIG_ORGS: AgenticAuthOnFileOrgTab[] = [
  { id: OrganizationType.NYCBS, label: "NYCBS Medical PA" },
  { id: OrganizationType.NYCBS_STAT, label: "NYCBS Medical PA Stat" },
  { id: OrganizationType.MBP, label: "MaryBird Medical" },
  { id: OrganizationType.CHC, label: "CHC Medical PA" },
  { id: OrganizationType.UCBC, label: "UCBC" },
  { id: OrganizationType.SUNSTATE, label: "SunState Medical Specialists" },
];
